import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-new',
    templateUrl: './new.component.svg',
    styleUrls: ['./new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewComponent {}
